import { StateCreator } from 'zustand';
import { DocumentSliceState, HistoryData } from 'store/types';
import { useBoundStore } from './index';

export const createDocumentSlice: StateCreator<DocumentSliceState> = () => ({
  historyData: {
    new_blocks: { title: [], text_content: [], json_content: [] },
    deleted_blocks: { title: [], text_content: [], json_content: [] },
    modified_blocks: { title: [], text_content: [], json_content: [] },

    new_articles: { title: [], text_content: [], json_content: [] },
    deleted_articles: { title: [], text_content: [], json_content: [] },
    modified_articles: { title: [], text_content: [], json_content: [] },

    new_sections: { title: [], text_content: [], json_content: [] },
    deleted_sections: { title: [], text_content: [], json_content: [] },
    modified_sections: { title: [], text_content: [], json_content: [] },
  },
});

export const setHistoryData = (historyData: HistoryData) => {
  useBoundStore.setState(() => ({ historyData }));
  console.log('History data set:', historyData);
};
